import React, { useState } from 'react';
import { Container, Tabs, Tab, Box } from '@mui/material';
import AdminTeams from './AdminTeams';
import AdminMatches from './AdminMatches';
import AdminSettings from './AdminSettings';
import AdminParticipants from './AdminParticipants';

const Admin = () => {
  const [tab, setTab] = useState(0);

  const handleTabChange = (event, newValue) => {
    setTab(newValue);
  };

  return (
    <Container maxWidth="lg" sx={{ px: { xs: 2, sm: 3, md: 4 } }}>
      <Box sx={{ borderBottom: 1, borderColor: 'divider', mb: 3 }}>
        <Tabs value={tab} onChange={handleTabChange} aria-label="admin tabs">
          <Tab label="Teams" />
          <Tab label="Matches" />
          <Tab label="Settings" />
          <Tab label="Participants" />
        </Tabs>
      </Box>
      <Box>
        {tab === 0 && <AdminTeams />}
        {tab === 1 && <AdminMatches />}
        {tab === 2 && <AdminSettings />}
        {tab === 3 && <AdminParticipants />}
      </Box>
    </Container>
  );
};

export default Admin;
